
<div class="minor-page-wrapper" fxLayout="column" fxLayoutAlign="start center">
    <div fxLayout="column" fxLayoutGap="10px" fxFlexFill>
        <div fxLayout="column" fxFlex>
            <div class="panel-headers" fxLayout="row" fxLayoutAlign="center center" style="height:40px;"> 
                eSign Documents
            </div>
            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="eSignDocumentsDataSource" matSort #eSignDocumentsSort="matSort">
                    <!-- Definition Column -->
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Document </th>
                        <td mat-cell *matCellDef="let element"> {{ element.description }} </td>
                    </ng-container>                    
                    <!-- Position Type -->
                    <ng-container matColumnDef="templateId">
                        <th mat-header-cell *matHeaderCellDef> Start Signing! </th>
                        <td mat-cell *matCellDef="let row">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <fa-icon style="cursor: pointer;" (click)="getSigningDocument(row)" [icon]="['fas', 'file-signature']"
                                    size="lg" fxFlex="35px">
                                </fa-icon>
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="eSignDocumentsColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: eSignDocumentsColumns;"></tr>
                </table>
                <mat-paginator #eSignDocumentsPaginator [pageSize]="20" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
                </mat-paginator>
            </div>
        </div>              
    </div>
</div>
